import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoadingShared } from './../../general/shared/loading-shared';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { SettingService } from './../../../data/repository/setting-repository/setting.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  messageBadge,
  SearchFaqResponse,
} from 'src/app/core/model/api-response/support-responce.model';
import { HostListener } from '@angular/core';

interface subcategories {
  id: string;
  name: string;
}
interface supportTitle {
  title: string;
  subcategories: subcategories[];
}
@Component({
  selector: 'app-support-page',
  templateUrl: './support-page.component.html',
  styleUrls: ['./support-page.component.scss'],
})
export class SupportPageComponent implements OnInit, OnDestroy {
  supportTitles: supportTitle[];
  txtQueryChanged: Subject<string> = new Subject<string>();
  faqs: SearchFaqResponse;
  searchText: string;
  isSearch: boolean = false;
  showLoading: boolean;
  showEdit: boolean = false;
  selectedType: string;
  faqId: null = null;
  subscriptions: Subscription[] = [];
  unReadMessage: messageBadge;
  constructor(
    private settingService: SettingService,
    private supportService: SupportService,
    private loadingShared: LoadingShared,
    private bottomsheetShared: BottomsheetShared
  ) {
    this.txtQueryChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((model) => {
        this.isSearch = true;
        this.searchText = model;
        this.getSearchFaq(this.searchText);
      });

    const closeButtomSheet =
      this.bottomsheetShared.closeBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.showEdit = false;
        }
      });
    const closeAndUpdateBottomsheet =
      this.bottomsheetShared.closeAndUpdateBottomsheetObs$.subscribe(
        (close) => {
          if (close) {
            this.showEdit = false;
          }
        }
      );
    const toggleMessage = this.supportService.messageBS.subscribe((res) => {
      this.showEdit = false;
      setTimeout(() => {
        this.selectedType = 'message';
        this.showEdit = true;
      }, 100);
    });

    this.subscriptions.push(
      closeButtomSheet,
      toggleMessage,
      closeAndUpdateBottomsheet
    );
  }

  ngOnInit() {
    this.loadingShared.showLoading();
    this.supportService.getSupportCategories().then((res) => {
      this.supportTitles = res
        .getData()
        .getSupportCategories()
        .categories.map((el) => {
          const subcategories: subcategories[] = el.subcategories.map((sb) => {
            return {
              id: sb._id,
              name: sb.name,
            };
          });
          return {
            title: el.name,
            subcategories,
          };
        });
    });
    this.supportService.getMessageBadge().then((res) => {
      console.log(res);

      this.unReadMessage = res.getData().getMessageBadgeResponce();
    });
    this.loadingShared.hideLoading();
  }
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  getSearchFaq(query: string) {
    this.supportService.getFaqSearchResponce(query).then((res) => {
      this.faqs = res.getData().getFaqSearchResponce();
    });
  }
  back() {
    this.settingService.goBack();
  }
  goToAnswer(id: string) {
    this.settingService.goToAnswer(id);
  }
  goToMessage() {
    this.settingService.goToMessageInbox();
  }
  search(query: string) {
    if (query.length <= 0) {
      this.isSearch = false;
    } else {
      this.txtQueryChanged.next(query);
    }
  }
  support() {
    this.showEdit = true;
    this.selectedType = 'support';
  }
  supportSelected(data: { id: string; title: string }) {
    this.settingService.goToFAQ(data);
    // if (index === 0) {
    //   this.settingService.goToFAQ();
    // } else if (index === 1) {
    //   this.settingService.goToReportProblem();
    // } else if (index === 2) {
    //   this.settingService.goToAboutUs();
    // }
  }
}
